/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CostProfileItem,
    CostProfileItemFromJSON,
    CostProfileItemFromJSONTyped,
    CostProfileItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface MonitoredObjectCostProfile
 */
export interface MonitoredObjectCostProfile {
    /**
     * 
     * @type {CostProfileItem}
     * @memberof MonitoredObjectCostProfile
     */
    fuel: CostProfileItem;
    /**
     * 
     * @type {CostProfileItem}
     * @memberof MonitoredObjectCostProfile
     */
    additives: CostProfileItem;
    /**
     * 
     * @type {CostProfileItem}
     * @memberof MonitoredObjectCostProfile
     */
    oil: CostProfileItem;
    /**
     * 
     * @type {CostProfileItem}
     * @memberof MonitoredObjectCostProfile
     */
    tires: CostProfileItem;
    /**
     * 
     * @type {CostProfileItem}
     * @memberof MonitoredObjectCostProfile
     */
    maintenance: CostProfileItem;
    /**
     * 
     * @type {CostProfileItem}
     * @memberof MonitoredObjectCostProfile
     */
    liabilityInsurance: CostProfileItem;
    /**
     * 
     * @type {CostProfileItem}
     * @memberof MonitoredObjectCostProfile
     */
    collisionInsurance: CostProfileItem;
    /**
     * 
     * @type {CostProfileItem}
     * @memberof MonitoredObjectCostProfile
     */
    personalInjuryInsurance: CostProfileItem;
    /**
     * 
     * @type {CostProfileItem}
     * @memberof MonitoredObjectCostProfile
     */
    parking: CostProfileItem;
    /**
     * 
     * @type {CostProfileItem}
     * @memberof MonitoredObjectCostProfile
     */
    cabinHeating: CostProfileItem;
    /**
     * 
     * @type {CostProfileItem}
     * @memberof MonitoredObjectCostProfile
     */
    telecomunicationsAndMonitoring: CostProfileItem;
    /**
     * 
     * @type {CostProfileItem}
     * @memberof MonitoredObjectCostProfile
     */
    washing: CostProfileItem;
    /**
     * 
     * @type {CostProfileItem}
     * @memberof MonitoredObjectCostProfile
     */
    lngCng: CostProfileItem;
    /**
     * 
     * @type {CostProfileItem}
     * @memberof MonitoredObjectCostProfile
     */
    electro: CostProfileItem;
}

export function MonitoredObjectCostProfileFromJSON(json: any): MonitoredObjectCostProfile {
    return MonitoredObjectCostProfileFromJSONTyped(json, false);
}

export function MonitoredObjectCostProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoredObjectCostProfile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fuel': CostProfileItemFromJSON(json['fuel']),
        'additives': CostProfileItemFromJSON(json['additives']),
        'oil': CostProfileItemFromJSON(json['oil']),
        'tires': CostProfileItemFromJSON(json['tires']),
        'maintenance': CostProfileItemFromJSON(json['maintenance']),
        'liabilityInsurance': CostProfileItemFromJSON(json['liability_insurance']),
        'collisionInsurance': CostProfileItemFromJSON(json['collision_insurance']),
        'personalInjuryInsurance': CostProfileItemFromJSON(json['personal_injury_insurance']),
        'parking': CostProfileItemFromJSON(json['parking']),
        'cabinHeating': CostProfileItemFromJSON(json['cabin_heating']),
        'telecomunicationsAndMonitoring': CostProfileItemFromJSON(json['telecomunications_and_monitoring']),
        'washing': CostProfileItemFromJSON(json['washing']),
        'lngCng': CostProfileItemFromJSON(json['lng_cng']),
        'electro': CostProfileItemFromJSON(json['electro']),
    };
}

export function MonitoredObjectCostProfileToJSON(value?: MonitoredObjectCostProfile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fuel': CostProfileItemToJSON(value.fuel),
        'additives': CostProfileItemToJSON(value.additives),
        'oil': CostProfileItemToJSON(value.oil),
        'tires': CostProfileItemToJSON(value.tires),
        'maintenance': CostProfileItemToJSON(value.maintenance),
        'liability_insurance': CostProfileItemToJSON(value.liabilityInsurance),
        'collision_insurance': CostProfileItemToJSON(value.collisionInsurance),
        'personal_injury_insurance': CostProfileItemToJSON(value.personalInjuryInsurance),
        'parking': CostProfileItemToJSON(value.parking),
        'cabin_heating': CostProfileItemToJSON(value.cabinHeating),
        'telecomunications_and_monitoring': CostProfileItemToJSON(value.telecomunicationsAndMonitoring),
        'washing': CostProfileItemToJSON(value.washing),
        'lng_cng': CostProfileItemToJSON(value.lngCng),
        'electro': CostProfileItemToJSON(value.electro),
    };
}


